export const aboutData = {
    title: "Who I am",
    description1: "Hello!",
    description2: " My name is Manvi Singhal. I am a 2nd year undergrad pursuing Bachelor's Degree in Computer Science Engineering at SRMIST. I am passionate about working on projects, participating in hackathons and learning new stuff. I am inclined towards Web Dev, App Dev and AI/ML. My interests include various other fields such as Astronomy and Physics. I love to gaze at the night sky, play my guitar and watch Netflix.",
    image: 2
}